// src/components/DataTable.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Typography,
  Grid,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import {
  getCompanySuppliersAction,
  getOrderPaginatedAction,
  getPoOrderDetailsAction,
} from './Action';

import moment from 'moment';
import {
  getOrderFinalStatusById,
  getRGBAColor,
  orderFinalStatusEnum,
  SupplierModuleTypeEnum,
} from '../../utils/settings';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useDispatch } from 'react-redux';

export default function DispatchStatusList() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBookingsList, setOrderBookingsList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [startEndDate, setStartEndDate] = useState({
    startDate: moment(moment().subtract(30, 'days')).format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });

  const [orderList, setOrderList] = useState();
  const [companiesList, setCompaniesList] = useState([]);
  const [companiesListWithFullDetails, setCompaniesListtWithFullDetails] =
    useState([]);
  const [statusList, setStatusList] = useState([]);

  const [company, setCompany] = useState(null);
  const [status, setStatus] = useState(null);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const getOrders = async () => {
    const params = new URLSearchParams();
    params.append('f', 'id$gte$0');
    params.append('o', 'id$desc');
    params.append('page', page + 1);
    params.append('page_size', rowsPerPage);
    params.append('is_buyer', true);

    if (startEndDate.startDate || startEndDate.endDate) {
      if (startEndDate.startDate) {
        params.append(
          'f',
          `date$gte$${moment(startEndDate.startDate)
            .startOf('day')
            .format('YYYY-MM-DD 00:00:00Z')}`,
        );
      }
      if (startEndDate.endDate) {
        params.append(
          'f',
          `date$lte$${moment(startEndDate.endDate)
            .endOf('day')
            .format('YYYY-MM-DD 23:59:00Z')}`,
        );
      }
    }
    if (company) {
      params.append('f', `supplier_id$eq$${company}`);
    }
    if (status) {
      params.append('f', `final_status$eq$${status}`);
    }

    const { data, error, message } = await getOrderPaginatedAction(params);

    if (!error) {
      setOrderList(data);
    }
  };

  const getCompany = async () => {
    const { data, error, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.dp_history_enabled,
    );
    if (!error) {
      let list = [];
      let listWithFullDetails = [];
      data.map((industry) => {
        industry.suppliers_list.map((supplier) => {
          list.push({
            id: supplier.id,
            name: supplier.name,
          });
          listWithFullDetails.push({
            ...supplier,
          });
        });
      });
      setCompaniesListtWithFullDetails(listWithFullDetails);
      setCompaniesList(list);
    } else return toast.error(message);
  };
  useEffect(() => {
    getOrders();
    getCompany();
    getStatusList();
  }, []);

  const setSupplierCompanyDetails = (supplier_id) => {
    const supplier = companiesListWithFullDetails.filter(
      (company) => company.id == supplier_id,
    );
    dispatch({
      type: 'STORE_COMPANY_DETAILS',
      companyDetails: supplier[0],
    });
  };

  const getStatusList = () => {
    let list = [];
    orderFinalStatusEnum.map((item) => {
      list.push({
        id: item.id,
        name: item.name,
      });
    });
    setStatusList(list);
  };

  useEffect(() => {
    if (company || status || startEndDate) {
      getOrders();
    }
  }, [company, status, startEndDate, page, rowsPerPage]);
  const handleClearAllFilters = () => {
    setCompany(null);
    setStatus(null);
    setStartEndDate({
      startDate: moment(moment().subtract(30, 'days')).format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    });
    setPage(0);
    setRowsPerPage(10);
  };

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        {' '}
        <Typography
          variant='h5'
          style={{ marginBottom: '2rem', fontWeight: 'bold' }}
        >
          Dispatch Status List
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ width: '70%' }}>
            <TextField
              label='Start Date'
              type='date'
              InputLabelProps={{ shrink: true }}
              value={startEndDate.startDate}
              sx={{ mr: 2 }}
              onChange={(e) => {
                setStartEndDate({
                  ...startEndDate,
                  startDate: e.target.value,
                });
              }}
            />
            <TextField
              label='End Date'
              type='date'
              value={startEndDate.endDate}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setStartEndDate({
                  ...startEndDate,
                  endDate: e.target.value,
                });
              }}
            />
            <FormControl sx={{ marginLeft: '2rem', width: '25%' }}>
              <InputLabel>Select Company</InputLabel>
              <Select
                value={company}
                label='Select Company'
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
              >
                {companiesList &&
                  companiesList.length > 0 &&
                  companiesList.map((company) => (
                    <MenuItem
                      value={company.id}
                      key={company.id}
                    >
                      {company.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: '2rem', width: '25%' }}>
              <InputLabel>Select Status</InputLabel>
              <Select
                value={status}
                label='Select Status'
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
              >
                {statusList &&
                  statusList.length > 0 &&
                  statusList.map((status) => (
                    <MenuItem
                      value={status.id}
                      key={status.id}
                    >
                      {status.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          <Button
            variant='contained'
            sx={{
              marginLeft: '2rem',
            }}
            color='error'
            onClick={handleClearAllFilters}
            endIcon={<RestartAltIcon />}
          >
            Clear All
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => navigate('/order-booking/po-list')}
          >
            Create New Dispatch
          </Button>
        </Box>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <TableContainer>
            <Table aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>User PO ID</TableCell>
                  <TableCell align='center'>Order ID</TableCell>
                  <TableCell align='center'>Date</TableCell>
                  {/* <TableCell>UOM</TableCell> */}
                  <TableCell align='center'>Status</TableCell>
                  <TableCell align='center'>Dispatch Qty</TableCell>
                  <TableCell align='center'>Delivered Qty</TableCell>
                  <TableCell align='center'>Pending Qty</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderList?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      cursor: 'pointer',
                    }}
                    onClick={async () => {
                      const { data, error, message } =
                        await getPoOrderDetailsAction({
                          order_id: row.order_id,
                        });

                      if (!error) {
                        dispatch({
                          type: 'SET_EDIT_PO_BOOKING_DETAILS',
                          data: data,
                        });

                        setSupplierCompanyDetails(
                          data?.order_details?.supplier_id,
                        );

                        dispatch({
                          type: 'IS_SECONDARY_ORDER',
                          data: false,
                        });

                        navigate('/order-booking/dispatch-status-details', {
                          state: {
                            orderID: row.order_id,
                          },
                        });
                      } else {
                        return toast.error(message);
                      }
                    }}
                  >
                    <TableCell align='center'>
                      {row.user_booking_id ? row.user_booking_id : '-'}
                    </TableCell>
                    <TableCell align='center'>
                      <Box
                        sx={{
                          alignItems: 'left',
                        }}
                      >
                        {row.order_id}
                        <Grid sx={{ fontSize: 'small', color: 'gray' }}>
                          {' '}
                          <Typography variant='body2'>
                            Ship to party:
                          </Typography>
                          {row.ship_to_parties.map((item, index) => {
                            return (
                              <Grid>
                                <Typography variant='body2'>
                                  {item.company_name}
                                </Typography>
                                {index !== row.ship_to_parties.length - 1 && (
                                  <Typography variant='body2'>,</Typography>
                                )}
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Box>
                    </TableCell>
                    <TableCell align='center'>
                      {moment(row?.date).format('DD MMM YYYY')}
                    </TableCell>

                    <TableCell
                      sx={{
                        width: '10rem',
                      }}
                      align='center'
                    >
                      <Box
                        sx={{
                          borderRadius: '10px',

                          textAlign: 'center',
                          backgroundColor: getRGBAColor(
                            getOrderFinalStatusById(row?.final_status).color,
                          ),
                        }}
                      >
                        <Typography
                          sx={{
                            color: getOrderFinalStatusById(row?.final_status)
                              .color,
                          }}
                        >
                          {getOrderFinalStatusById(row?.final_status).name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell align='center'>{`${row.order_details[0].dispatch_plan_quantity.quantity_in_metric_ton} ${row.order_details[0].dispatch_plan_quantity.unit}`}</TableCell>
                    <TableCell align='center'>{`${row.order_details[0].delivered_quantity.quantity_in_metric_ton} ${row.order_details[0].delivered_quantity.unit}`}</TableCell>
                    <TableCell align='center'>{`${row.order_details[0].pending_quantity.quantity_in_metric_ton} ${row.order_details[0].pending_quantity.unit}`}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component='div'
            count={100}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelDisplayedRows={({ from, to, count, page }) =>
              `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
            }
          />
        </Paper>
      </Container>
    </>
  );
}
